(() => {
  const SELECTORS = {
    status: '[data-lanjing-moq-status]',
    pageCheckout: '#checkout',
    drawerCheckout: '#CartDrawer-Checkout',
    dynamicButtons: '.additional-checkout-buttons'
  };

  const getActiveStatus = (button) => {
    if (button && button.closest('cart-drawer')) return button.closest('cart-drawer').querySelector(SELECTORS.status);
    return document.querySelector('.cart__footer-wrapper ' + SELECTORS.status) || document.querySelector(SELECTORS.status);
  };

  const stateFrom = (status) => ({
    met: status?.dataset.moqMet === 'true',
    remaining: Number(status?.dataset.moqRemaining || 0),
    minimum: Number(status?.dataset.moqMin || 25),
    overrides: Number(status?.dataset.overrideFailures || 0)
  });

  const applyButtonState = (button) => {
    if (!button) return;
    const status = getActiveStatus(button);
    if (!status) return;
    const state = stateFrom(status);
    const blocked = !state.met;
    button.disabled = blocked;
    button.setAttribute('aria-disabled', String(blocked));
    button.classList.toggle('lanjing-moq-blocked', blocked);
    button.dataset.lanjingMoqBlocked = String(blocked);
    if (blocked) {
      button.dataset.originalLabel ||= button.textContent.trim();
      button.textContent = state.overrides > 0 ? 'Complete Product Minimums' : `Add ${state.remaining} More Piece${state.remaining === 1 ? '' : 's'}`;
    } else if (button.dataset.originalLabel) {
      button.textContent = button.dataset.originalLabel;
    }
  };

  const applyDynamicButtons = () => {
    document.querySelectorAll(SELECTORS.dynamicButtons).forEach((wrap) => {
      const status = wrap.closest('.cart__footer-wrapper')?.querySelector(SELECTORS.status) || document.querySelector('.cart__footer-wrapper ' + SELECTORS.status);
      wrap.classList.toggle('lanjing-moq-hidden', !!status && status.dataset.moqMet !== 'true');
    });
  };

  const refresh = () => {
    document.querySelectorAll(`${SELECTORS.pageCheckout}, ${SELECTORS.drawerCheckout}`).forEach(applyButtonState);
    applyDynamicButtons();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(`${SELECTORS.pageCheckout}, ${SELECTORS.drawerCheckout}`);
    if (button?.dataset.lanjingMoqBlocked === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      getActiveStatus(button)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (submitter?.dataset.lanjingMoqBlocked === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      getActiveStatus(submitter)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);

  const observer = new MutationObserver(() => requestAnimationFrame(refresh));
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', refresh);
  window.addEventListener('pageshow', refresh);
  refresh();
})();

// V1.9: after any Shopify cart mutation, wait for sections to render and re-apply MOQ controls.
(() => {
  const schedule = () => {
    window.requestAnimationFrame(() => {
      document.dispatchEvent(new CustomEvent('lanjing:cart-sections-updated'));
    });
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('.quantity__input, [name="updates[]"]')) setTimeout(schedule, 500);
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('quantity-input, cart-remove-button, quick-order-list')) setTimeout(schedule, 500);
  });

  if (window.subscribe && window.PUB_SUB_EVENTS?.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, schedule);
  }
})();


// V1.10 drawer polish: close mobile navigation and reset drawer scroll when cart opens.
(() => {
  const resetDrawer = () => {
    document.querySelectorAll('.lj-header__mobile[open], .lj-header__mobile-brands[open]').forEach((details) => details.removeAttribute('open'));
    const items = document.querySelector('cart-drawer-items');
    if (items) items.scrollTop = 0;
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('#cart-icon-bubble')) setTimeout(resetDrawer, 0);
  });

  document.addEventListener('cart:open', resetDrawer);
})();


// V1.11: refresh MOQ button state after Shopify replaces cart sections.
(() => {
  const run = () => {
    requestAnimationFrame(() => {
      document.dispatchEvent(new CustomEvent('lanjing:cart-sections-updated'));
    });
  };
  if (window.subscribe && window.PUB_SUB_EVENTS?.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, run);
  }
  document.addEventListener('shopify:section:load', run);
})();


/* V1.14: recover from a horizontal position cached before the mobile gallery
   overflow fix. The page itself must stay at x=0; only media rails may scroll. */
(() => {
  const resetProductHorizontalPosition = () => {
    if (window.innerWidth > 749 || !document.body.classList.contains('template-product')) return;
    document.documentElement.scrollLeft = 0;
    document.body.scrollLeft = 0;
  };

  window.addEventListener('pageshow', resetProductHorizontalPosition);
  window.addEventListener('resize', resetProductHorizontalPosition, { passive: true });
  document.addEventListener('DOMContentLoaded', () => {
    resetProductHorizontalPosition();
    requestAnimationFrame(resetProductHorizontalPosition);
  }, { once: true });
})();
